import PropTypes from 'prop-types';
import React from 'react';
import { Modal, Button } from 'antd';

const PwdTip = props => {
  const handleCancel = () => {
    props.onCancel();
  };

  return (
    <Modal
      title="提示"
      centered
      visible={props.visible}
      destroyOnClose={false}
      closable={false}
      width={400}
      className="help-dialog"
      footer={
        <Button
          type="primary"
          onClick={() => {
            handleCancel();
            props.handlePasswordState(true, true);
          }}
        >
          去修改
        </Button>
      }
      zIndex={1005}
    >
      <div className="helpItem" style={{ height: '100px' }}>
        系统检测到您的密码过于简单，请先修改密码。
      </div>
    </Modal>
  );
};
PwdTip.propTypes = {
  visible: PropTypes.bool.isRequired,
  onCancel: PropTypes.func.isRequired,
  userInfo: PropTypes.object,
  onUserInfoUpdated: PropTypes.func,
  handlePasswordState: PropTypes.func,
};
export default PwdTip;
